import React from 'react';

import { Box } from '@components/Restyle';
import { Skeleton } from '@components/shared/Skeleton';
import theme from '@themes/theme';

/**
 * Copy-Task search result row placeholder — mirrors `TaskSearchResult`'s
 * bordered row: a name line, a 100px project-tag chip, and the trailing
 * 24x24 app-icon box.
 */
export const TaskSearchResultSkeleton: React.FC<{ testID?: string }> = ({
  testID = 'task-search-result-skeleton',
}) => (
  <Box
    testID={testID}
    borderColor='grey02'
    borderWidth={1}
    justifyContent='space-between'
    flexDirection='row'
    alignItems='center'
    padding='m'>
    <Box flex={1} marginRight='s'>
      <Skeleton variant='text' width='70%' />
    </Box>
    <Skeleton
      variant='rect'
      width={100}
      height={20}
      borderRadius='xxs'
      style={{ marginRight: theme.spacing.m }}
    />
    <Skeleton variant='rect' width={24} height={24} borderRadius='xxxs' />
  </Box>
);
